<template>
	<!-- 会员详情 -->
	<div>
		<!-- v-show="$route.meta.showFather" -->
		<div v-show="$route.meta.showFather">
			<div class="pad-16 mb-16 box-shadow">
				<el-table ref="multipleTable" :data="tableData" style="width: 100%" class="box-table" @select="select"
					@selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
					<el-table-column label="会员名称" prop="name" align="center">
						<template slot-scope="scope">{{ scope.row.name }}</template>
					</el-table-column>
					<el-table-column prop="status" label="观看课程权限" width="" align="center">
						<template slot-scope="scope">{{ scope.row.status==true?'开通':'关闭' }}</template>
					</el-table-column>
					<el-table-column prop="unlockCount" label="解锁专家名额" width="" align="center" show-overflow-tooltip>
					</el-table-column>
					<!-- <el-table-column label="会员名称" align="center">
                        <template slot-scope="scope">{{ scope.row.date }}</template>
                    </el-table-column> -->
					<el-table-column prop="price" label="原价" align="center">
					</el-table-column>
					<el-table-column prop="preferentialPrice" label="优惠价" align="center" show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="updateTime" label="期限" align="center" show-overflow-tooltip>
						<template slot-scope="scope">{{ utils.getNowTime(scope.row.updateTime) }}</template>
					</el-table-column>
					<!-- <el-table-column prop="radio" label="选择" align="center">
                        <el-radio v-model="scope.row.radio" label="1">备选项</el-radio>
                    </el-table-column> -->
					<el-table-column type="selection" width="55" align="center">
					</el-table-column>
				</el-table>

			</div>
			<el-pagination class="pages" v-show="pageInline.tableTotal>0" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :page-sizes="pageGroup.sizes" :page-size="pageGroup.size"
				layout="total, sizes, prev, pager, next, jumper" :total="pageInline.tableTotal">
			</el-pagination>
			<div class="pad-16 mb-16 box-shadow">
				<div class="is-flex mb-24">
					<div class="left-icon"></div>
					<p class="left-p">支付方式</p>
				</div>
				<div class="is-flex jus-bet" style="align-items: flex-end;">
					<img src="../../../assets/head/wxzhifu.png" alt="" class="wxzf">
					<div class="is-flex apply">
						<p>总计:</p>
						<p>￥{{price?price:'0'}}</p>
					</div>
				</div>
			</div>
			<div class="is-flex jus-bet" style="margin-top: 40px;">
				<div></div>
				<div class="zhifuan is-flex">
					<p @click="xianxia">线下支付</p>
					<p @click="payment">立即支付￥{{price?price:'0'}}</p>
				</div>
				<div></div>
			</div>
			<!-- 线下支付弹窗 -->
			<el-dialog title="" :visible.sync="dialogPay" width="40%" :before-close="handleClose">
				<div class="pays is-flex">
					<img src="../../../assets/expert/dingwei.png" alt="">
					<p style="color: white;">可直接打款至对公账户，并添加客服微信，将支付凭证发给工作人员</p>
				</div>
				<div class="is-flex jus-bet align-base">
					<div>
						<p class="size-2 f-16 mb-21">付款账户</p>
						<div class="is-flex mb-8 align-base">
							<p class="size-1">账户名称</p>
							<p class="size-2">{{accountName}}</p>
						</div>
						<div class="is-flex mb-8 align-base">
							<p class="size-1">开户行</p>
							<p class="size-2">{{backName}}</p>
						</div>
						<div class="is-flex mb-8 align-base">
							<p class="size-1">对公账户</p>
							<p class="size-2">{{corporateAccount}}</p>
						</div>
					</div>
					<div style="text-align: center;">
						<p class="size-2 f-16 mb-16">客服微信</p>
						<img :src="wxQrCode" alt="" class="wid-30">
					</div>
					<div></div>
				</div>
			</el-dialog>

		</div>
		<router-view></router-view>

	</div>
</template>

<script>
	import {
		getInfo
	} from '@/api/api.js';
	import {
		getLevelPage,
		getMemberOrder
	} from '@/api/personal/api.js';
	import {
		orderSubmit,
		getPayment
	} from '@/api/activity/api.js';
	export default {
		components: {},
		data() {
			return {
				infoShow: true,
				taus: '',
				tableData: [],
				multipleSelection: [],
				radioSelected: '',
				dialogPay: false,
				isMultiple: false,
				wxQrCode: '',
				accountName: '',
				backName: '',
				corporateAccount: '',
				page: 1,
				limit: this.pageGroup.size,
				//分页对象
				pageInline: {
					tableSizes: this.pageGroup.sizes, //显示条数分组
					tableTotal: 10, // 默认数据总数
				},
				userInfo: {
					areaCode: '',
					cityCode: '',
					provinceCode: '',
					provinceName: '',
					cityName: '',
					areaName: '',
					name: '',
					workUnit: '',
					workTypeId: '',
					duties: '',
					userId: '',
					memberId: '',
					memberName: '',
					memberPrice: '',
					payMethod: 1
				},
				price: ''
			}
		},
		created() {
			this.userInfo = this.$store.state.activity.user;
		},
		mounted() {
			this.getInfos();
			this.getList();

		},
		methods: {
			getInfos() {
				getInfo().then(res => {
						this.wxQrCode = res.data.wxQrCode;
						this.accountName = res.data.accountName;
						this.backName = res.data.backName;
						this.corporateAccount = res.data.corporateAccount;
					})
					.catch(error => {});
			},
			getList() {
				let params = {
					pageNo: this.page,
					pageSize: this.pageGroup.size,
				}
				getLevelPage(params).then(res => {
						let list = res.data.list;
						let newarr = [];
						list.forEach((item) => {
							newarr.push(Object.assign(item, {
								className: 'normal'
							}))
						})
						this.tableData = newarr;
						console.log(this.tableData, 'this')
						this.pageInline.tableTotal = res.data.total;
					})
					.catch(error => {

					});
			},
			//页容量改变时会触发
			handleSizeChange(size) {
				this.limit = size;
				this.getList();
			},
			//当前页改变时会触发
			handleCurrentChange(currentPage) {
				this.page = currentPage;
				this.getList();
			},
			select(selection, row) {
				if (Object.prototype.toString.call(selection[0]) === '[object Object]') {
					row.className = "tableSelectedRowBgColor";
				} else {
					row.className = "normal";
				}
				this.$refs.multipleTable.clearSelection();
				if (selection.length === 0) { // 判断selection是否有值存在
					this.price = 0;
					this.userInfo.memberId = '';
					this.userInfo.memberName = '';
					return;
				};
				// console.log('点击', selection, row);
				this.$refs.multipleTable.toggleRowSelection(row, true);
				this.price = row.preferentialPrice;
				this.userInfo.memberId = row.id;
				this.userInfo.memberName = row.name;
			},
			handleSelectionChange(val) {
				if (val.length > 1) {
					this.$refs.multipleTable.clearSelection()
					this.$refs.multipleTable.toggleRowSelection(val.pop())
					val[0].className = "normal";

					// this.multipleSelection = val;
				} else {
					// val[0].className = "tableSelectedRowBgColor";
					// this.multipleSelection = val;
				}
				// console.log(this.multipleSelection, '--multipleSelection')
				// this.price = this.multipleSelection[0].preferentialPrice;

			},
			// 选中背景色
			tableRowClassName({
				row
			}) {
				return row.className;
			},
			payment() {
				if (this.price == '') {
					this.$message.warning('请先选择一条会员数据');
					return false;
				} else {
					this.userInfo.memberPrice = this.price;
					let params = this.userInfo;
					getMemberOrder(params).then(res => {
						if (res.code == 0) {
							this.submitMember(res.data)
							// this.$router.push('/personal/member/payment')
						}
					})
				}
				// 跳转微信支付页面
				// 失败跳转失败页面
				// this.$router.push('/personal/member/paymentSuccess')
				// this.$router.push('/personal/member/paymentFail')
			},
			submitMember(orderId) {
				getPayment({
						orderId: orderId,
						type: 1
					}).then(res => {
						// console.log(res.data, '--')
						// this.payId = res.data
						this.orderPay(res.data);
					})
					.catch(error => {

					});
			},
			orderPay(id) {
				let params = {
					id: id,
					channelCode: 'wx_native',
					returnUrl: 'https://www.zgjyzjw.com/personal/member/payment'
					// returnUrl:'https://www.zgjyzjw.com/member/payment?id='+this.form.eventId
				}
				orderSubmit(params).then(res => {
						this.displayContent = res.data.displayContent; // 要生成二维码
						// console.log(res.data, '--111')
						// 跳转支付页面生成二维码
						this.$router.push({
							name: '/member/payment',
							params: {
								id: id,
								displayContent: this.displayContent,
								price: this.price
							}
						})

					})
					.catch(error => {

					});
			},
			handleClose() {
				this.dialogPay = false
			},
			// 线下支付
			xianxia() {
				if (this.price == '') {
					this.$message.warning('请先选择一条会员数据');
					return false;
				} else {
					this.userInfo.memberPrice = this.price;
					this.userInfo.payMethod = 2;
					let params = this.userInfo;
					getMemberOrder(params).then(res => {
						if (res.code == 0) {
							this.dialogPay = true
						}
					})
				}
			}
		}
	}
</script>


<style scoped>
	.pad-16 {
		padding: 32px 16px;

	}

	.box-shadow {
		box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.is-flex {
		display: flex;
		align-items: center;
	}

	.jus-bet {
		justify-content: space-between;
	}


	.mb-24 {
		margin-bottom: 24px;
	}

	.mb-16 {
		margin-bottom: 16px;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px;
	}

	.left-p {
		font-size: 20px;
		color: #222222;
		font-family: font5;
		font-weight: normal;
		padding-left: 10px;
	}

	.wxzf {
		width: 5.5rem;
		height: 5.5rem;
	}

	.erweima {
		width: 6.25rem;
		height: 6.25rem;
	}

	.apply p:first-child {
		color: #222222;
		font-size: 14px;
		font-family: font3;
		margin-right: 1rem;
	}

	.apply p:last-child {
		color: #FF5533;
		font-size: 28px;
		font-family: font5;
	}

	.te-c {
		text-align: center;
	}

	.box-table {
		color: #222222;
	}

	/deep/.el-table th.el-table__cell>.cell {
		color: #222222;
		font-weight: normal;
		white-space: nowrap;
	}

	/deep/.el-table th.el-table__cell.is-leaf {
		border: none;
	}

	/deep/.el-table::before {
		height: 0;
	}

	/*   /deep/.el-table__header{
        background-color: #F2F5FA;
    } */

	/deep/.el-table th.el-table__cell {
		background: #F2F5FA;
	}

	/deep/.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #fff;
		border: 1px solid #CCCCCC;
	}

	/deep/.el-checkbox__inner {
		border: 2px solid #CCCCCC;
	}

	/deep/.el-checkbox__inner::after {
		border: 1px solid #3377FF;
		border-left: 0;
		border-top: 0;
		width: 3px;
		height: 7px;
		border-width: 2px;
	}

	/deep/.tableSelectedRowBgColor td {
		background-color: #3377FF;
		color: #FFFFFF;
	}

	/deep/.normal td {
		background-color: #ffffff;
		color: #222222;
	}

	/deep/.box-table .el-table__row:hover>td {
		background-color: transparent !important;
	}

	/deep/.box-table .tableSelectedRowBgColor:hover>td {
		background-color: #3377FF !important;
		color: #FFFFFF;
	}

	/deep/.box-table .normal:hover>td {
		background-color: #ffffff !important;
		color: #333;
	}

	/deep/.el-table--enable-row-transition .el-table__body td.el-table__cell {
		border-bottom: 0;
	}

	.zhifuan p {
		color: #FFFFFF;
		font-family: font3;
		border-radius: 4px 4px 4px 4px;
		font-size: 1rem;
	}

	.zhifuan p:first-child {
		background-color: #FF944D;
		padding: 12px 58px;
		margin-right: 16px;
	}

	.zhifuan p:last-child {
		background-color: #3377FF;
		padding: 12px 21px;
	}

	/deep/.el-dialog__headerbtn {
		background: url("../../../assets/expert/closes.png");
		background-size: cover;
		height: 20px;
		width: 20px;
		top: 4%;

		i {
			display: none;
			/* // 在这里隐藏弹窗默认的关闭图标 */
		}
	}

	/deep/.el-dialog__header {
		background-color: #FAAD14;
		height: 2.25rem;
		padding: 0;
		border-radius: 8px 8px 0 0;
	}

	/deep/.el-dialog {
		border-radius: 8px 8px 8px 8px;
	}

	.pays img {
		width: 1.375rem;
		height: 1.375rem;
		margin-right: 0.5rem;
	}

	.pays {
		position: absolute;
		top: 3%;
	}

	.pays p {
		color: #FFFFFF;
		font-size: 14px;
		font-family: font3;
	}

	.size-1 {
		color: #999999;
		margin-right: 1rem;
		font-family: font3;
		text-align: right;
		width: 6.25rem;
		white-space: nowrap;
	}

	.size-2 {
		color: #222222;
		font-size: 0.875rem;
		font-family: font3;
		white-space: nowrap;
	}

	.f-16 {
		font-size: 16px !important;
		text-align: center;
		font-family: font5 !important;
	}

	.mb-21 {
		margin-bottom: 1.3125rem;
	}

	.align-base {
		align-items: flex-start;
	}

	/deep/.el-dialog__body {
		padding: 1.25rem;
	}

	/deep/ .el-table__header-wrapper .el-checkbox {
		display: none;
	}

	.mb-8 {
		margin-bottom: 0.5rem;
	}

	/deep/.pages .el-pagination__editor.el-input {
		width: 3.125rem;
	}
</style>